<!--  zoom -->
<template>
  <div class="mock-zoom">
    <div>
      <zoom-banner :appDetail="appDetail"
                   v-if="appDetail.videoType === 'ZOOM'"></zoom-banner>
      <tencent-video :appDetail="appDetail"
                     v-if="appDetail.videoType === 'TENCENT'"></tencent-video>
    </div>
    <zoom-notification v-if="appDetail.videoType === 'ZOOM'"></zoom-notification>
    <div>
      <zoom-detail :appDetail="appDetail"
                   :id="id"></zoom-detail>
    </div>
    <div>
      <component :is="componentId"
                 :appDetail="appDetail"
                 @on-feedback="saveFeedback"
                 @on-confirm-success="getAppDeatil"></component>
    </div>
     <!-- 聊天 -->
    <div>
      <websocket-chat-modal></websocket-chat-modal>
    </div>
    <!--  -->
    <!-- 讨论区 -->
    <div class="mentee-zoom-dicuss">
      <div>
        <div class="mentee-zoom-dicuss-con">
          <zlr-discuss title="Other Information">
            <template v-if="commentList.length> 0">
              <zlr-discuss-item v-for="(item, index) in commentList"
                                :key="index"
                                :avatar="item.avaurl"
                                :name="item.createRole === 'MENTEE'? item.menteeName:item.mentorName"
                                :time="item.createTime"
                                :content="item.content"></zlr-discuss-item>
            </template>
            <zlr-empty v-else></zlr-empty>
          </zlr-discuss>
        </div>
      </div>
    </div>
    <!-- 发表讨论 -->
    <div class="mentee-zoom-add-dicuss"
         style="display:none;">
      <div>
        <div>
          <discuss-add title="Add discussion"
                       :avatar="userAvatar"
                       ref="addDisc"
                       v-model="content">
            <Button class="zlr-btn-primary"
                    :loading="isSub"
                    @click="sendDiscussHandle">Send</Button>
          </discuss-add>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getAppDeatil } from '@/api/appointment'
import { createComments, getCommentsPage } from '@/api/comments'
import { saveFeedback } from '@/api/feedback'
// components
import ZoomBanner from './components/mock-zoom-banner'
import TencentVideo from './tencent/tencent-video'
import ZoomDetail from './components/zoom-detail'
import discuss from '_c/discuss'
import DiscussAdd from '_c/discuss-add/discuss-add'
import ZlrEmpty from '_c/empty/empty'
import ConfirmTime from './components/confirm-time'
import FeedbackInterview from './components/feeedback-interivew'
import FeedbackDetail from './feedback-detail'
import ZoomNotification from './zoom/notification'
import { mapState } from 'vuex'
import { subSuc } from '@/constant'
import WebsocketChatModal from './tencent/websocket-chat-modal'
export default {
  name: 'mentee-mock-zoom',
  components: {
    ZoomBanner,
    TencentVideo,
    ZoomDetail,
    ZlrDiscuss: discuss.ZlrDiscuss,
    ZlrDiscussItem: discuss.ZlrDiscussItem,
    DiscussAdd,
    ZlrEmpty,
    ConfirmTime,
    FeedbackInterview,
    ZoomNotification,
    WebsocketChatModal
  },
  data () {
    return {
      programId: this.$route.params.programId,
      componentId: '',
      id: this.$route.query.id,
      appDetail: {},
      commentList: [],
      content: '',
      isSub: false
    }
  },
  computed: {
    ...mapState({
      'userAvatar' (state) {
        return state.user.userAvatar
      }
    })
  },
  mounted () {
    this.getAppDeatil()
    this.getCommentsPage()
  },
  methods: {
    getAppDeatil () {
      getAppDeatil({
        id: this.id
      }).then(res => {
        this.appDetail = res.data.model
        this.mapComponents()
      })
    },
    mapComponents () {
      let status = this.appDetail.statu
      let name = ''
      switch (status) {
        case 'TO_BE_COMPLETE_MENTOR':
          name = ConfirmTime
          break
        case 'TO_FEEDBACK':
          name = FeedbackInterview
          break
        case 'COMPLETE':
        case 'HAS_EVALUATE':
          name = FeedbackDetail
      }
      this.componentId = name
    },
    // 获取评论列表
    getCommentsPage () {
      getCommentsPage({
        appId: this.id
      }).then(res => {
        this.commentList = res.data.page.result
      })
    },
    // 发表评论
    sendDiscussHandle () {
      if (!this.content) return false
      this.isSub = true
      createComments({
        type: 'APPOINTMENT',
        appId: this.id,
        content: this.content
      }).then(res => {
        this.$refs['addDisc'].resetHtml()
        this.getCommentsPage()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isSub = false
      })
    },
    // 提交feedback
    saveFeedback (data) {
      saveFeedback(data).then(() => {
        this.$zlr_message(subSuc, 'success')
        this.getAppDeatil()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.$refs['component'].handleComplete()
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
